/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form/immutable';
import AmrForm from './layout';
import { formValidation } from './validation';
import {
  getSelectedEntityId,
  userHasUpdatePermission,
  userHasRemoveLockPermission,
  isCreating,
  isUpdating,
} from '../../../redux/modules/entities/selectors';
import {
  selectAmrFormInitialValues,
  getCurrentParentFormValues,
  getSelectableVersionList,
  isCreatingEntity,
  onSubmitClick,
  submitAmrFormData,
  selectTypesForDisplay,
  selectRequestTypesForDisplay,
  formTypeHasSubtypes,
  formSelectedRequestType,
  handleTermsSubmit,
  getSubmittedValues,
  getViewData,
  getProcessedViewData,
  getDisplayData,
  getStatus,
  getArtifactFailedDeleted,
  getArtifactFailedLocked,
  getArtifactsProcessedCount,
  getInteractionsProcessedCount,
  getInteractionsRemainingCount,
  getAnswerIfAPIProcessingHasFinished,
  getErrorCount
} from '../../../redux/modules/entities/amr/selectors';
import { submitAmrForm }  from '../../../redux/modules/entities/amr/actions';
import { entitiesMetaData } from '../../../redux/modules/entities/metaData';
import { formSubmission, createFormName } from '../../../redux/modules/form/selectors';
import store from '../../../redux/store';

const CreateAlpsForm = compose(
  connect(createFormName),
  reduxForm({
    onSubmit: (values, dispatch, props) => {
     onSubmitClick(values, dispatch, props, store.getState());
     submitAmrFormData(values, dispatch, props, store.getState());
    },
    validate: formValidation,
    destroyOnUnmount: true,
  })
)(AmrForm);

export function mapStateToProps(state) {
  return {
    initialValues: selectAmrFormInitialValues(state),
    userHasUpdatePermission: userHasUpdatePermission(state),
    isCreatingEntity: isCreatingEntity(state),
    isSaving: isUpdating(state) || isCreating(state),
    key: getSelectedEntityId(state),
    actionTypes: entitiesMetaData.alps.actionTypes,
    artifactTypes: selectTypesForDisplay(state),
    requestTypeList:selectRequestTypesForDisplay(state),
    artifactSubtypes: entitiesMetaData.alps.artifactSubtypes,
    currentFormValues: getCurrentParentFormValues(state),
    selectableVersions: getSelectableVersionList(state),
    typeHasSubtypes: formTypeHasSubtypes(state),
    selectedRequestType: formSelectedRequestType(state),
    submittedValues:getSubmittedValues(state),
    sidePanelData:getProcessedViewData(state),
    statusRequestDetails:getStatus(state),
    artifactFilesDeleted:getArtifactFailedDeleted(state),
    artifactFailedLocked:getArtifactFailedLocked(state),
    artifactsProcessedCount:getArtifactsProcessedCount(state),
    interactionsProcessedCount:getInteractionsProcessedCount(state),
    interactionsRemainingCount:getInteractionsRemainingCount(state),
    errorCount:getErrorCount(state),
    hasAPIProcessingFinished:getAnswerIfAPIProcessingHasFinished(state),
    removeLockPermission:userHasRemoveLockPermission(state)
  };
}


export default connect(mapStateToProps)(CreateAlpsForm);
